import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  admissionPersonPicture: {},
  commentFiles: []
};

const slice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setAdmissionPersonPicture(state, action) {
      state.admissionPersonPicture = action.payload;
    },
    deleteAdmissionPersonPicture(state) {
      state.admissionPersonPicture = {};
    },
    addCommentFile(state, action) {
      state.commentFiles.push(action.payload);
    },
    deleteCommentFile(state, action) {
      state.commentFiles = state.commentFiles.filter(
        (file) => file.name !== action.payload.name
      );
    },
    deleteAllCommentFile(state) {
      state.commentFiles = [];
    }
  }
});

export const reducer = slice.reducer;

export const setAdmissionPersonPicture = (file) => (dispatch) => {
  dispatch(slice.actions.setAdmissionPersonPicture(file));
};

export const deleteAdmissionPersonPicture = () => (dispatch) => {
  dispatch(slice.actions.deleteAdmissionPersonPicture());
};

export const addCommentFile = (newFileInfo) => (dispatch) => {
  const newFile = { id: newFileInfo.id, name: newFileInfo.file.name };
  dispatch(slice.actions.addCommentFile(newFile));
};

export const deleteCommentFile = (file) => (dispatch) => {
  const deleteFile = { name: file.name };
  dispatch(slice.actions.deleteCommentFile(deleteFile));
};

export const deleteAllCommentFile = () => (dispatch) => {
  dispatch(slice.actions.deleteAllCommentFile());
};

export default slice;
